/* Honey Bloom fun extras */
(function () {
  var cfg = window.HBFUN || {};
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  if (cfg.bounce) root.classList.add('hbf-bounce');
  if (cfg.scroll) root.classList.add('hbf-scroll');
  if (cfg.softType) root.classList.add('hbf-soft-type');

  /* ---- Hover scroll on template cards ---- */
  var fullCache = {};
  function fullFor(handle) {
    if (!fullCache[handle]) {
      fullCache[handle] = fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p || !p.media) return null;
          var m = p.media.filter(function (x) { return x.media_type === 'image' && (x.alt || '').indexOf('#full') > -1; })[0];
          if (!m) return null;
          var src = m.src || (m.preview_image && m.preview_image.src);
          return src ? src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=720' : null;
        }).catch(function () { return null; });
    }
    return fullCache[handle];
  }
  function attach(media, img) {
    if (media.dataset.hbfScroll) return;
    media.dataset.hbfScroll = '1';
    if (cfg.scrollHint && !media.querySelector('.card__scroll-hint')) {
      var hint = document.createElement('span');
      hint.className = 'card__scroll-hint';
      hint.textContent = cfg.scrollHint;
      media.appendChild(hint);
    }
    var over = false;
    function start() {
      if (!over) return;
      var box = media.getBoundingClientRect().height;
      var h = img.getBoundingClientRect().height || img.naturalHeight * (media.clientWidth / (img.naturalWidth || 1));
      var dist = Math.max(0, h - box);
      var dur = Math.min(30, Math.max(6, dist / 110));
      media.style.setProperty('--hbf-y', (-dist) + 'px');
      media.style.setProperty('--hbf-dur', (reduce ? 0 : dur) + 's');
      media.classList.add('is-scrolling');
      var hn = media.querySelector('.card__scroll-hint');
      if (hn) hn.style.setProperty('opacity', '1', 'important');
    }
    function go() {
      over = true;
      if (img.complete && img.naturalHeight) { requestAnimationFrame(function () { requestAnimationFrame(start); }); }
      else { img.loading = 'eager'; img.addEventListener('load', start, { once: true }); }
    }
    var zone = media.closest('.card') || media.closest('.tcard') || media;
    zone.addEventListener('mouseenter', go);
    zone.addEventListener('mouseleave', function () {
      over = false;
      media.style.setProperty('--hbf-dur', '0.6s');
      media.style.setProperty('--hbf-y', '0px');
      media.classList.remove('is-scrolling');
      var hn = media.querySelector('.card__scroll-hint');
      if (hn) hn.style.setProperty('opacity', '0', 'important');
    });
    if (zone.matches(':hover')) go();
  }
  function bindScroll(scope) {
    if (!cfg.scroll || !canHover) return;
    scope = scope || document;
    scope.querySelectorAll('.card__media').forEach(function (media) {
      var img = media.querySelector('.card__fullscroll');
      if (img) attach(media, img);
    });
    /* Template cards on collection pages (tcard): load the #full screenshot on first hover */
    scope.querySelectorAll('.tcard__thumb').forEach(function (thumb) {
      if (thumb.dataset.hbfWired) return;
      thumb.dataset.hbfWired = '1';
      var m = (thumb.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      if (!m) return;
      var handle = m[1];
      function prep() {
        if (thumb.querySelector('.card__fullscroll')) return;
        fullFor(handle).then(function (src) {
          if (!src || thumb.querySelector('.card__fullscroll')) return;
          var img = document.createElement('img');
          img.className = 'card__fullscroll';
          img.alt = '';
          img.setAttribute('aria-hidden', 'true');
          img.src = src;
          thumb.appendChild(img);
          attach(thumb, img);
          var z = thumb.closest('.tcard') || thumb;
          if (z.matches(':hover')) z.dispatchEvent(new Event('mouseenter'));
        });
      }
      thumb.addEventListener('mouseenter', prep, { once: true });
      if ('requestIdleCallback' in window) requestIdleCallback(prep, { timeout: 4000 }); else setTimeout(prep, 2500);
    });
  }

  /* ---- Hero sticker ---- */
  function heroSticker() {
    var tpl = document.getElementById('hb-hero-sticker');
    var device = document.querySelector('.dhero__device');
    if (!tpl || !device || device.querySelector('.hb-sticker--hero')) return;
    device.appendChild(tpl.content.cloneNode(true));
  }

  /* ---- Float in on scroll ---- */
  function floatIn() {
    if (!cfg.float || reduce || !('IntersectionObserver' in window)) return;
    var sel = 'main h2, main .h2, main .eyebrow, main .card, main .cframe, main .hbq__card, main .blog-card, main .article-card, main .values-strip__item';
    var els = Array.prototype.slice.call(document.querySelectorAll(sel)).filter(function (el) {
      return !el.closest('[data-reveal], .dhero, .hbsh, .drawer, .modal, [class*="popup"], .hbk, .product__info, .cart');
    });
    if (!els.length) return;
    root.classList.add('hbf-float');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    var groups = new Map();
    els.forEach(function (el) {
      var parent = el.parentElement;
      var i = groups.get(parent) || 0;
      groups.set(parent, i + 1);
      el.style.setProperty('--hbf-delay', Math.min(i, 5) * 0.08 + 's');
      el.classList.add('hbf-rise');
      io.observe(el);
    });
    /* Safety: never leave content hidden */
    setTimeout(function () { els.forEach(function (el) { if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-in'); }); }, 1500);
  }

  /* ---- Sparkle cursor on the hero ---- */
  function sparkles() {
    if (!cfg.sparkle || reduce || !canHover) return;
    var hero = document.querySelector('.hbsh') || document.querySelector('.dhero');
    if (!hero) return;
    var colors = cfg.sparkleColors || ['#C25E8A', '#A27BC2', '#E9A93A', '#E98A6E'];
    var last = 0;
    function spark(x, y) {
      var s = document.createElement('span');
      s.className = 'hbf-spark';
      var c = colors[Math.floor(Math.random() * colors.length)];
      var size = 14 + Math.random() * 14;
      s.style.left = x + 'px';
      s.style.top = y + 'px';
      s.style.width = s.style.height = size + 'px';
      s.style.margin = (-size / 2) + 'px 0 0 ' + (-size / 2) + 'px';
      s.style.setProperty('--dx', (Math.random() * 30 - 15) + 'px');
      s.style.setProperty('--dy', (Math.random() * 18 - 22) + 'px');
      s.style.setProperty('--glow', c);
      s.innerHTML = '<svg viewBox="0 0 20 20"><path fill="' + c + '" d="M10 0c1 5.5 4.5 9 10 10-5.5 1-9 4.5-10 10-1-5.5-4.5-9-10-10C5.5 9 9 5.5 10 0z"/></svg>';
      document.body.appendChild(s);
      setTimeout(function () { s.remove(); }, 1150);
    }
    hero.addEventListener('mousemove', function (e) {
      var now = Date.now();
      if (now - last < 35) return;
      last = now;
      spark(e.clientX, e.clientY);
      if (Math.random() < 0.5) spark(e.clientX + (Math.random() * 24 - 12), e.clientY + (Math.random() * 24 - 12));
    });
  }

  /* ---- Template quiz ---- */
  function quizzes() {
    document.querySelectorAll('[data-hbq]').forEach(function (el) {
      if (el.dataset.hbqReady) return;
      el.dataset.hbqReady = '1';
      var data;
      try { data = JSON.parse(el.querySelector('[data-hbq-data]').textContent); } catch (e) { return; }
      var qs = data.questions || [];
      var products = data.products || [];
      var step = 0, picks = [];
      var stage = el.querySelector('[data-hbq-stage]');
      var dots = el.querySelector('[data-hbq-dots]');

      function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

      function renderDots() {
        var h = '';
        for (var i = 0; i <= qs.length; i++) h += '<span class="hbq__dot' + (i === step ? ' is-on' : '') + '"></span>';
        dots.innerHTML = h;
      }

      function renderQuestion() {
        renderDots();
        var q = qs[step];
        var h = '<div class="hbq__panel"><p class="hbq__step-label">' + esc(data.stepLabel || 'Question') + ' ' + (step + 1) + ' / ' + qs.length + '</p>';
        h += '<h3 class="hbq__q">' + esc(q.question) + '</h3><div class="hbq__answers">';
        q.answers.forEach(function (a, i) { h += '<button type="button" class="hbq__answer" data-i="' + i + '">' + esc(a.label) + '</button>'; });
        h += '</div>';
        if (step > 0) h += '<button type="button" class="hbq__back" data-back>' + esc(data.backLabel || 'Back') + '</button>';
        h += '</div>';
        stage.innerHTML = h;
        stage.querySelectorAll('.hbq__answer').forEach(function (b) {
          b.addEventListener('click', function () {
            picks[step] = q.answers[+b.dataset.i];
            step++;
            if (step < qs.length) renderQuestion(); else renderResults();
          });
        });
        var back = stage.querySelector('[data-back]');
        if (back) back.addEventListener('click', function () { step--; renderQuestion(); });
      }

      function score(p) {
        var tags = (p.tags || []).map(function (t) { return t.toLowerCase(); });
        var s = 0;
        picks.forEach(function (a, i) {
          var w = (qs[i] && qs[i].weight) || 1;
          (a.tags || []).forEach(function (t) { if (tags.indexOf(t) > -1) s += w; });
        });
        return s;
      }

      function renderResults() {
        step = qs.length;
        renderDots();
        var ranked = products.map(function (p, i) { return { p: p, s: score(p), i: i }; })
          .sort(function (a, b) { return b.s - a.s || a.i - b.i; })
          .slice(0, data.results || 3);
        var h = '<div class="hbq__panel"><p class="hbq__step-label">' + esc(data.resultLabel || 'Your matches') + '</p>';
        h += '<h3 class="hbq__q">' + esc(data.resultHeading || 'We think you\'ll love these') + '</h3><div class="hbq__results">';
        ranked.forEach(function (r, i) {
          var p = r.p;
          h += '<a class="hbq__result" href="' + esc(p.url) + '">' + (p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
            '<div class="hbq__result-body">' + (i === 0 ? '<span class="hbq__result-tag">' + esc(data.bestLabel || 'Best match') + '</span>' : '') +
            '<p class="hbq__result-title">' + esc(p.title) + '</p><p class="hbq__result-price">' + esc(p.price) + '</p></div></a>';
        });
        h += '</div><div class="hbq__actions">';
        if (data.allUrl) h += '<a class="hbq__btn" href="' + esc(data.allUrl) + '">' + esc(data.allLabel || 'See all templates') + '</a>';
        h += '<button type="button" class="hbq__btn hbq__btn--ghost" data-restart>' + esc(data.restartLabel || 'Start over') + '</button></div></div>';
        stage.innerHTML = h;
        stage.querySelector('[data-restart]').addEventListener('click', function () { step = 0; picks = []; renderQuestion(); });
      }

      if (qs.length) renderQuestion();
    });
  }


  /* ---- Animated template showcase hero ---- */
  function showcases() {
    document.querySelectorAll('[data-hbsh]').forEach(function (el) {
      if (el.dataset.hbshReady) return;
      el.dataset.hbshReady = '1';
      var interval = (parseFloat(el.dataset.interval) || 7) * 1000;
      var speed = parseFloat(el.dataset.speed) || 90;
      var screens = [el.querySelector('.hbsh__screen'), el.querySelector('.hbsh__phone-screen')];
      var phone = el.querySelector('.hbsh__phone');
      var count = el.querySelectorAll('.hbsh__screen .hbsh__slide').length;
      if (!count) return;
      var i = 0, timer = null, paused = false;

      function scrollShot(screen, idx) {
        if (!screen) return null;
        var slide = screen.querySelectorAll('.hbsh__slide')[idx];
        var img = slide && slide.querySelector('.hbsh__shot');
        if (!img) return slide;
        img.style.transition = 'none';
        img.style.transform = 'translateY(0)';
        if (reduce) return slide;
        function run() {
          var dist = Math.max(0, img.getBoundingClientRect().height - screen.getBoundingClientRect().height);
          var secs = interval / 1000 - 0.6;
          var go = Math.min(dist, speed * secs * (screen.clientWidth / 520));
          void img.offsetWidth;
          img.style.transition = 'transform ' + secs + 's cubic-bezier(.45, .05, .55, .95)';
          img.style.transform = 'translateY(' + (-go) + 'px)';
        }
        if (img.complete && img.naturalHeight) requestAnimationFrame(run); else img.addEventListener('load', run, { once: true });
        return slide;
      }

      function show(n) {
        i = (n + count) % count;
        screens.forEach(function (sc) {
          if (!sc) return;
          sc.querySelectorAll('.hbsh__slide').forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        });
        el.querySelectorAll('.hbsh__pill').forEach(function (p, k) { p.classList.toggle('is-active', k === i); });
        el.querySelectorAll('.hbsh__dot').forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
        var ps = screens[1] && screens[1].querySelectorAll('.hbsh__slide')[i];
        if (phone) phone.classList.toggle('is-empty', !(ps && ps.querySelector('.hbsh__shot')));
        scrollShot(screens[0], i);
        scrollShot(screens[1], i);
      }
      function next() { if (!paused) show(i + 1); }
      function start() { clearInterval(timer); timer = setInterval(next, interval); }

      el.querySelectorAll('.hbsh__dot').forEach(function (d) {
        d.addEventListener('click', function () { show(+d.dataset.go); start(); });
      });
      var stage = el.querySelector('.hbsh__stage');
      if (stage && canHover) {
        stage.addEventListener('mouseenter', function () { paused = true; });
        stage.addEventListener('mouseleave', function () { paused = false; });
      }
      document.addEventListener('visibilitychange', function () { paused = document.hidden; });
      show(0);
      if (count > 1) start();
    });
  }

  function init() {
    heroSticker();
    bindScroll();
    floatIn();
    sparkles();
    quizzes();
    showcases();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { bindScroll(e.target); quizzes(); heroSticker(); showcases(); });
})();
